// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vue2Filters from 'vue2-filters'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'vant/lib/index.css'
import Vant, { Lazyload } from 'vant'

Vue.config.productionTip = false
Vue.use(Vue2Filters)
Vue.use(Antd)
Vue.use(Vant)
Vue.use(Lazyload, {
  lazyComponent: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js